import { SET_SEO_DATA } from './seodata.types';
export var setSeoData = function setSeoData(seoData) {
  return {
    type: SET_SEO_DATA,
    seoData: seoData
  };
};